import { useAdminScopeTerms } from '../../lib/adminScopeTerms';

export const AdminScopeSection = ({ exclude, children }) => {
  const { view } = useAdminScopeTerms();
  return view === exclude ? null : children;
};